import {createAxiosInstance} from './base.api'

const projectApi = 'projects'

export const createProject = (project, successMethod, errorMethod) => createAxiosInstance(projectApi).post('/', project)
.then((res) => successMethod(res))
.catch((error) => errorMethod(error))


export const getProject = (id, errorMethod) => createAxiosInstance(projectApi).get(`/${id}`)
.catch(error => errorMethod(error))

export const updateProject = (id, project, successMethod, errorMethod) => createAxiosInstance(projectApi).put(`/${id}`, project)
.then(response => successMethod(response))
.catch(error => errorMethod(error))


export const projectOrderUp = (id, errorMethod) => createAxiosInstance(projectApi).put(`/${id}/order-up`, {})
.catch(error => errorMethod(error))

export const projectOrderDown = (id, errorMethod) => createAxiosInstance(projectApi).put(`/${id}/order-down`, {})
.catch(error => errorMethod(error))

export const projectStart = (id, errorMethod) => createAxiosInstance(projectApi).put(`/${id}/start`, {})
.catch(error => errorMethod(error))

export const projectPause = (id, errorMethod) => createAxiosInstance(projectApi).put(`/${id}/pause`, {})
.catch(error => errorMethod(error))

export const projectFinish = (id, errorMethod) => createAxiosInstance(projectApi).put(`/${id}/finish`, {})
.catch(error => errorMethod(error))

export const projectCancel = (id, errorMethod) => createAxiosInstance(projectApi).put(`/${id}/cancel`, {})
.catch(error => errorMethod(error))


export const createTaskProject = (id, task, successMethod, errorMethod) => createAxiosInstance(projectApi).post(`/${id}/tasks`, task)
.then((res) => successMethod(res))
.catch((error) => errorMethod(error))

export const bulkCreateTaskProject = (id, tasks, successMethod, errorMethod) => createAxiosInstance(projectApi).post(`/${id}/bulk-tasks`, tasks)
.then((res) => successMethod(res))
.catch((error) => errorMethod(error))

export const createProjectResource = (taskid, projectResource, successMethod, errorMethod) => createAxiosInstance(projectApi).post(`/${taskid}/projectResources`, projectResource)
.then((res) => successMethod(res))
.catch((error) => errorMethod(error))
